<!-- Display Mode -->
@if (!editMode) {
  <div
    class="message-bubble">
    <div class="message-text">
      {{ textValue }}
    </div>
  </div>
}

<!-- Edit Settings -->
@if (editMode) {
  <div>
    <div>
      <textarea
        rows="6"
        [(ngModel)]="textValue"
        (ngModelChange)="onTextChanged()"
        class="input is-small is-fullwidth"
      type="text"></textarea>
    </div>
  </div>
}

@if (showText) {
  <topo-text-edit
    [isActive]="showText"
    title="{{ 'MANAGEMENT.COMMUNICATION-CENTER.MODIFY-TEXT' | translate }}"
    [value]="textValue"
    [backgroundCanClose]="false"
    (textUpdated)="updateText($event)"
  (cancelText)="cancelText()"></topo-text-edit>
}
